export default "__VITE_ASSET__BWidFUVs__"